import useQueryParameters from 'utils/hooks/routes/useQueryParameters'

import { GAMES_ORDER_DEFAULT } from '../../../containers/Games/constants'
import { GameOrder } from '../../../containers/GamesBlock/hooks/types'

const orderKey = 'order'

export default function useOrder() {
  const [order, changeOrder] = useQueryParameters<GameOrder>(orderKey)

  return { order: order ?? GAMES_ORDER_DEFAULT, changeOrder }
}
